import { render, staticRenderFns } from "./cusMOrderAmountReport.vue?vue&type=template&id=5678de66"
import script from "./cusMOrderAmountReport.vue?vue&type=script&lang=js"
export * from "./cusMOrderAmountReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports